import { Pipe, PipeTransform } from "@angular/core";
import _ from 'lodash';

@Pipe({ name: 'AppointmentStatusPipe' })
export class AppointmentStatusPipe implements PipeTransform {
    transform(value: string): string {
        if (value === "Added") {
            return "_General_Added_Text_";
        } else if (value === "Assigned") {
            return "_General_Assigned_Text_";
        } else if (value === "Cancelled") {
            return "_General_Cancelled_Text_";
        } else if (value === "Completed") {
            return "_General_Completed_Text_";
        } else if (value === "No Show") {
            return "_General_No_Show_Text_";
        } else if (value === "Checked-In") {
            return "_General_CheckedIn_Text_";
        } else if (value === "Remote-Checked-In") {
            return "_General_RemoteCheckedIn_Text";
        }

        throw new Error("Unexpected code path reached!")
    }
}
